(function () {
  var css = '.vpick{display:flex;flex-direction:column;gap:12px}' +
    '.vpick__row{display:flex;flex-wrap:wrap;gap:8px}' +
    '.vpick__btn{display:inline-flex;align-items:center;gap:10px;min-height:44px;padding:0 20px;border:1px solid var(--stone-600);border-radius:2px;background:transparent;color:var(--text);font-size:14px;line-height:1.2;transition:border-color var(--dur-fast) var(--ease-out),background var(--dur-fast) var(--ease-out),color var(--dur-fast) var(--ease-out)}' +
    '.vpick__btn:hover{border-color:var(--text)}' +
    '.vpick__btn.is-active{background:var(--text);color:var(--bg);border-color:var(--text)}' +
    '.vpick__btn.is-out{color:var(--text-muted)}' +
    '.vpick__btn.is-out.is-active{background:transparent;color:var(--text);border-color:var(--text)}' +
    '.vpick__btn:focus-visible{outline:1px solid var(--accent);outline-offset:2px}' +
    '.vpick__so{font:400 10px/1 var(--font-mono);letter-spacing:.12em;text-transform:uppercase;opacity:.75}';

  function build() {
    var selects = document.querySelectorAll('[data-variant-select]');
    if (!selects.length) return;
    if (!document.getElementById('vpick-css')) {
      var st = document.createElement('style'); st.id = 'vpick-css'; st.textContent = css; document.head.appendChild(st);
    }
    Array.prototype.forEach.call(selects, function (s) {
      if (s.getAttribute('data-vpick-done')) return;
      s.setAttribute('data-vpick-done', '1');
      var lab = s.closest('label') || s.parentNode;
      var heading = lab.querySelector('.label');
      var box = document.createElement('div'); box.className = 'vpick';
      var title = document.createElement('span'); title.className = 'label';
      title.textContent = heading ? heading.textContent : 'Options';
      var row = document.createElement('div'); row.className = 'vpick__row';
      row.setAttribute('role', 'radiogroup'); row.setAttribute('aria-label', title.textContent);
      var btns = [];
      Array.prototype.forEach.call(s.options, function (o) {
        var b = document.createElement('button');
        b.type = 'button'; b.className = 'vpick__btn'; b.setAttribute('role', 'radio');
        b.appendChild(document.createTextNode(o.textContent.replace(/\s*[—-]\s*Sold out\s*$/i, '').trim()));
        if (o.disabled) {
          b.classList.add('is-out');
          var so = document.createElement('span'); so.className = 'vpick__so'; so.textContent = 'Sold out'; b.appendChild(so);
        }
        var on = o.value === s.value;
        b.classList.toggle('is-active', on); b.setAttribute('aria-checked', on ? 'true' : 'false');
        b.addEventListener('click', function () {
          s.value = o.value;
          btns.forEach(function (x) { var a = x === b; x.classList.toggle('is-active', a); x.setAttribute('aria-checked', a ? 'true' : 'false'); });
          s.dispatchEvent(new Event('change', { bubbles: true }));
        });
        btns.push(b); row.appendChild(b);
      });
      box.appendChild(title); box.appendChild(row);
      lab.parentNode.insertBefore(box, lab.nextSibling);
      lab.hidden = true;
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', build); else build();
})();